import initialState from './initialState';
import {
  CALCULATIONS_HISTORY_GET_LIST_INIT,
  CALCULATIONS_HISTORY_GET_LIST_SUCCESS,
  CALCULATIONS_HISTORY_GET_LIST_FAILURE,
  CALCULATIONS_HISTORY_GET_GROUPS_INIT,
  CALCULATIONS_HISTORY_GET_GROUPS_SUCCESS,
  CALCULATIONS_HISTORY_GET_GROUPS_FAILURE,
  CALCULATIONS_HISTORY_GET_PERIODS_LIST_INIT,
  CALCULATIONS_HISTORY_GET_PERIODS_LIST_SUCCESS,
  CALCULATIONS_HISTORY_GET_PERIODS_LIST_FAILURE,
  CALCULATIONS_HISTORY_GET_CALCULATION_UNITS_INIT,
  CALCULATIONS_HISTORY_GET_CALCULATION_UNITS_SUCCESS,
  CALCULATIONS_HISTORY_GET_CALCULATION_UNITS_FAILURE,
  CALCULATIONS_HISTORY_GET_POLYNOMIALS_LIST_INIT,
  CALCULATIONS_HISTORY_GET_POLYNOMIALS_LIST_SUCCESS,
  CALCULATIONS_HISTORY_GET_POLYNOMIALS_LIST_FAILURE,
  CALCULATIONS_HISTORY_EXPORT_CALCULATIONS_INIT,
  CALCULATIONS_HISTORY_EXPORT_CALCULATIONS_SUCCESS,
  CALCULATIONS_HISTORY_EXPORT_CALCULATIONS_FAILURE,
  CALCULATIONS_HISTORY_GET_CALCULATION_DEPURATION_DETAIL_INIT,
  CALCULATIONS_HISTORY_GET_CALCULATION_DEPURATION_DETAIL_SUCCESS,
  CALCULATIONS_HISTORY_GET_CALCULATION_DEPURATION_DETAIL_FAILURE,
  CALCULATIONS_HISTORY_GET_METRIC_DATA_INIT,
  CALCULATIONS_HISTORY_GET_METRIC_DATA_SUCCESS,
  CALCULATIONS_HISTORY_GET_METRIC_DATA_FAILURE,
  CALCULATIONS_HISTORY_EXPORT_METRIC_DATA_INIT,
  CALCULATIONS_HISTORY_EXPORT_METRIC_DATA_SUCCESS,
  CALCULATIONS_HISTORY_EXPORT_METRIC_DATA_FAILURE,
  CALCULATIONS_HISTORY_GET_CALCULATION_INSTANCES_DETAIL_INIT,
  CALCULATIONS_HISTORY_GET_CALCULATION_INSTANCES_DETAIL_SUCCESS,
  CALCULATIONS_HISTORY_GET_CALCULATION_INSTANCES_DETAIL_FAILURE,
  CALCULATIONS_HISTORY_DELETE_CALCULATION_INSTANCE_PREPARE_INIT,
  CALCULATIONS_HISTORY_DELETE_CALCULATION_INSTANCE_INIT,
  CALCULATIONS_HISTORY_DELETE_CALCULATION_INSTANCE_SUCCESS,
  CALCULATIONS_HISTORY_DELETE_CALCULATION_INSTANCE_FAILURE,
  CALCULATIONS_HISTORY_RESET
} from '../../actions/calculationsHistory/types';
import ReducersTooling from '../../../tooling/reducersTooling';

export default function calculationsHistory(state = initialState, action) {
  switch (action.type) {      
    case CALCULATIONS_HISTORY_GET_LIST_INIT:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateInitList(initialState, state, action, "list");
    case CALCULATIONS_HISTORY_GET_LIST_SUCCESS:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateSuccessList(initialState, state, action, "list");
    case CALCULATIONS_HISTORY_GET_LIST_FAILURE:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateFailureList(initialState, state, action, "list");
    case CALCULATIONS_HISTORY_GET_GROUPS_INIT:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateInitList(initialState, state, action, "groupsList");
    case CALCULATIONS_HISTORY_GET_GROUPS_SUCCESS:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateSuccessList(initialState, state, action, "groupsList");
    case CALCULATIONS_HISTORY_GET_GROUPS_FAILURE:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateFailureList(initialState, state, action, "groupsList");
    case CALCULATIONS_HISTORY_GET_PERIODS_LIST_INIT:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateInitList(initialState, state, action, "periodsList");
    case CALCULATIONS_HISTORY_GET_PERIODS_LIST_SUCCESS:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateSuccessList(initialState, state, action, "periodsList");
    case CALCULATIONS_HISTORY_GET_PERIODS_LIST_FAILURE:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateFailureList(initialState, state, action, "periodsList");
    case CALCULATIONS_HISTORY_GET_CALCULATION_UNITS_INIT:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateInitList(initialState, state, action, "calculationUnitsFilter");
    case CALCULATIONS_HISTORY_GET_CALCULATION_UNITS_SUCCESS:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateSuccessList(initialState, state, action, "calculationUnitsFilter");
    case CALCULATIONS_HISTORY_GET_CALCULATION_UNITS_FAILURE:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateFailureList(initialState, state, action, "calculationUnitsFilter");
    case CALCULATIONS_HISTORY_GET_POLYNOMIALS_LIST_INIT:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateInitList(initialState, state, action, "polynomialsList");
    case CALCULATIONS_HISTORY_GET_POLYNOMIALS_LIST_SUCCESS:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateSuccessList(initialState, state, action, "polynomialsList");
    case CALCULATIONS_HISTORY_GET_POLYNOMIALS_LIST_FAILURE:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateFailureList(initialState, state, action, "polynomialsList");
    case CALCULATIONS_HISTORY_EXPORT_CALCULATIONS_INIT:
      return ReducersTooling.generalReducers.getFetchTypeNewStateInit(initialState, state, action, "exportCalculations");
    case CALCULATIONS_HISTORY_EXPORT_CALCULATIONS_SUCCESS:
      return ReducersTooling.generalReducers.getFetchTypeNewStateSuccess(initialState, state, action, "exportCalculations");
    case CALCULATIONS_HISTORY_EXPORT_CALCULATIONS_FAILURE:
      return ReducersTooling.generalReducers.getFetchTypeNewStateFailure(initialState, state, action, "exportCalculations");
    case CALCULATIONS_HISTORY_GET_CALCULATION_DEPURATION_DETAIL_INIT:
      return ReducersTooling.generalReducers.getFetchTypeNewStateInit(initialState, state, action, "calculationDepurationDetail");
    case CALCULATIONS_HISTORY_GET_CALCULATION_DEPURATION_DETAIL_SUCCESS:
      return ReducersTooling.generalReducers.getFetchTypeNewStateSuccess(initialState, state, action, "calculationDepurationDetail");
    case CALCULATIONS_HISTORY_GET_CALCULATION_DEPURATION_DETAIL_FAILURE:
      return ReducersTooling.generalReducers.getFetchTypeNewStateFailure(initialState, state, action, "calculationDepurationDetail");
    case CALCULATIONS_HISTORY_GET_METRIC_DATA_INIT:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateInitList(initialState, state, action, "calculationDepurationDetailMetricData");
    case CALCULATIONS_HISTORY_GET_METRIC_DATA_SUCCESS:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateSuccessList(initialState, state, action, "calculationDepurationDetailMetricData");
    case CALCULATIONS_HISTORY_GET_METRIC_DATA_FAILURE:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateFailureList(initialState, state, action, "calculationDepurationDetailMetricData");
    case CALCULATIONS_HISTORY_EXPORT_METRIC_DATA_INIT:
      return ReducersTooling.generalReducers.getFetchTypeNewStateInit(initialState, state, action, "calculationDepurationDetailExportMetricData");
    case CALCULATIONS_HISTORY_EXPORT_METRIC_DATA_SUCCESS:
      return ReducersTooling.generalReducers.getFetchTypeNewStateSuccess(initialState, state, action, "calculationDepurationDetailExportMetricData");
    case CALCULATIONS_HISTORY_EXPORT_METRIC_DATA_FAILURE:
      return ReducersTooling.generalReducers.getFetchTypeNewStateFailure(initialState, state, action, "calculationDepurationDetailExportMetricData");
    case CALCULATIONS_HISTORY_GET_CALCULATION_INSTANCES_DETAIL_INIT:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateInitList(initialState, state, action, "calculationInstancesDetail");
    case CALCULATIONS_HISTORY_GET_CALCULATION_INSTANCES_DETAIL_SUCCESS:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateSuccessList(initialState, state, action, "calculationInstancesDetail");
    case CALCULATIONS_HISTORY_GET_CALCULATION_INSTANCES_DETAIL_FAILURE:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateFailureList(initialState, state, action, "calculationInstancesDetail");
    case CALCULATIONS_HISTORY_DELETE_CALCULATION_INSTANCE_PREPARE_INIT:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStatePrepareDelete(initialState, state, action, "deleteCalculationInstance");
    case CALCULATIONS_HISTORY_DELETE_CALCULATION_INSTANCE_INIT:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateInitDelete(initialState, state, action, "deleteCalculationInstance");
    case CALCULATIONS_HISTORY_DELETE_CALCULATION_INSTANCE_SUCCESS:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateSuccessDelete(initialState, state, action, "deleteCalculationInstance");
    case CALCULATIONS_HISTORY_DELETE_CALCULATION_INSTANCE_FAILURE:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateFailureDelete(initialState, state, action, "deleteCalculationInstance");
    case CALCULATIONS_HISTORY_RESET:
      return initialState;
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./source/client/reducers/calculationsHistory/index.js